import {v4 as uuid} from "uuid";

import {createContext, useContext, useState, useCallback} from "react";
import {RaikoUploaderStatus} from "./RaikoUploaderStatus";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {RaikoUploadFileTypes} from "./RaikoUploadFileTypes";
import {showDarkMessage, showErrorMessage, showSuccessMessage} from "@moeindal/base-raiko-panel-components";

const RaikoUploadManagerContext = createContext();

function handleUpdatePercent(setUploads, id) {
    return (percent) => {
        setUploads((prev) =>
            prev.map((u) => (u.id === id ? {...u, progress: percent} : u))
        );
    };
}

function handleChangeUploadTaskStatus(setUploads, id, status, percent, message) {
    setUploads((prev) =>
        prev.map((u) =>
            u.id === id ? {...u, status: status, progress: percent, message} : u
        )
    );
}

export function RaikoUploadManagerProvider({children}) {
    const [uploads, setUploads] = useState([]);
    const [pendingCount, setPendingCount] = useState(0)


    const startUpload = useCallback((file, uploadFn, targetBucketId, type = RaikoUploadFileTypes.DOCUMENT) => {
        const id = uuid();
        const controller = new AbortController();

        const task = {
            id,
            file,
            type,
            status: RaikoUploaderStatus.IN_PROGRESS,
            progress: 0,
            controller,
            message: "",
            notification: false
        };

        setUploads((prev) => [...prev, task]);
        setPendingCount(prev => prev + 1)

        showSuccessMessage("فایل جدید به صف بارگزاری ها اضافه شد.")

        uploadFn(file, targetBucketId, handleUpdatePercent(setUploads, id), controller.signal)
            .then(() => {

                let _task = null


                uploads.map((item) => {
                    console.log(`condition is ${item.id === id} and ${item.id} === ${id}`)
                    if (item.id === id) {
                        _task = item;
                    }
                })


                console.log("item is ", _task)


                if (_task !== null && _task.notification === true) {
                    showSuccessMessage(`بارگذاری فایل  ${task.file.name} باموفقیت انجام شد.`)
                }

                handleChangeUploadTaskStatus(setUploads, id, RaikoUploaderStatus.DONE, 100);


            })
            .catch((err) => {

                console.log("error ", err)

                if (err.message.includes("ERR_NETWORK_CHANGED")) {
                    console.log("err",)
                    handleChangeUploadTaskStatus(
                        setUploads,
                        id,
                        RaikoUploaderStatus.ABORTED,
                        0,
                        "⚠️ اتصال شبکه تغییر کرده است!"
                    );
                    if (task.notification === true) {
                        showErrorMessage("خطا در بارگذاری فایل,اتصال شبکه تغییر کرده است! ")
                    }
                } else if (err.response) {
                    handleChangeUploadTaskStatus(
                        setUploads,
                        id,
                        RaikoUploaderStatus.ABORTED,
                        0,
                        detectServerErrorMessage(err)
                    );
                    if (task.notification === true) {
                        showErrorMessage(`خطا در بارگذاری فایل,${detectServerErrorMessage(err)} `)

                    }
                } else {
                    handleChangeUploadTaskStatus(
                        setUploads,
                        id,
                        RaikoUploaderStatus.CANCELED,
                        0
                    );
                    if (task.notification === true) {
                        // showErrorMessage("خطا در بارگذاری فایل,اتصال شبکه تغییر کرده است! ")
                    }
                }
            }).finally(() => {
            setPendingCount(prev => prev - 1)
        })
    }, []);

    const cancelUpload = useCallback((id) => {
        setUploads((prev) => {
            const upload = prev.find((u) => u.id === id);
            if (upload && upload.controller) {
                upload.controller.abort();
            }
            return prev.map((u) =>
                u.id === id ? {...u, status: RaikoUploaderStatus.CANCELED} : u
            );
        });
    }, []);

    const changeNotificationState = useCallback((id, state) => {
        setUploads((prev) => {
            showDarkMessage(state ? "اعلان فعال شد." : "اعلان غیر فعال شد.")
            return prev.map((u) =>
                u.id === id ? {...u, notification: state} : u
            );
        });


    }, []);

    const deleteItem = useCallback((id) => {
        setUploads((prev) => prev.filter((u) => u.id !== id));
    }, []);

    return (
        <RaikoUploadManagerContext.Provider
            value={{uploads, pendingCount, startUpload, cancelUpload, deleteItem, changeNotificationState}}
        >
            {children}
        </RaikoUploadManagerContext.Provider>
    );
}

export const useRaikoUploadManager = () => useContext(RaikoUploadManagerContext);
